import {
  globalpaymentsInitiatePayment,
  globalpaymentsAddressValidate,
  globalPaymentsGenerateToken,
  GlobalpaymentSaveCard,
  globalPaymentsVerifyCard,
} from '@kfc-global/react-shared/redux/Actions/PaymentsAction';
import {
  paymentTrancationSuccessHandler,
  paymentTrancationErrorHandler,
  updateClickPlaceOrderState,
  checkPaymentMethod,
} from 'common/utilities/PaymentUtils';
import { PAYMENT_TENDER_TYPES, PROD } from 'common/constants/SharedConstants';
import AuthManager from '@kfc-global/react-shared/auth/AuthManager';
import {
  loadScript,
  redirectToPaymentFailurePage,
  redirectToAccountPage,
  isCurrentPageRedirectFromRNA,
  isPickupDisposition,
  isDeliveryDisposition
} from 'common/utilities/utils';
import { config } from '@kfc-global/react-shared/config/config.utils';
import { APP_ENVIRONMENT, GLOBAL_PAYMENTS_3DS_FILE_URL } from '@kfc-global/react-shared/config/config.constants';
import networkConfig from '@kfc-global/react-shared/network/config';
import PAYMENT_CONSTANTS from 'organisms/Payment/constants/PaymentConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { getCustomerInfo } from '@kfc-global/react-shared/redux/Actions/OrderservAction';

const {
  GLOBAL_PAYMENTS_CONSTANTS,
  GLOBAL_PAYMENTS_ADDRESS_VALIDTAION_PAYLOAD_CONSTANTS,
  GLOBAL_PAYMENTS_BROWSER_DATA_VALUES,
  VERIFIED,
  PAYMENT_CREDIT_DEBIT_CARD_VIEW_TEMPLATES,
  MULTIPLE,
  SINGLE,
} = PAYMENT_CONSTANTS;

const {POSTAL_CODE, ADDRESS} = PAYMENT_CREDIT_DEBIT_CARD_VIEW_TEMPLATES;

const { gloablPaymentCheckVersionUrl, gloablPayment3DSIntitiateAuthUrl } = networkConfig;

export const getGlobalPaymentsEnvironment = () => {
  return config(APP_ENVIRONMENT) === PROD
    ? GLOBAL_PAYMENTS_CONSTANTS?.GLOBAL_PAYMENTS_PRODUCTION
    : GLOBAL_PAYMENTS_CONSTANTS?.GLOBAL_PAYMENTS_SANDBOX;
};

export const getBillingOrShippingAddress = (checkoutDetails) => {
  if(checkoutDetails?.billingAddressAndSaveCard?.defaultAddressSelected && isDeliveryDisposition(checkoutDetails?.service)) {
    return {
      streetAddress1: checkoutDetails?.cartData?.deliveryAddress?.addressLines[0],
      streetAddress2: checkoutDetails?.cartData?.deliveryAddress?.addressLines[1],
      streetAddress3: '',
      city: checkoutDetails?.cartData?.deliveryAddress?.city,
      postalCode: checkoutDetails?.cartData?.deliveryAddress?.pinCode,
      countryCode: checkoutDetails?.countryCodeNumeric,
      state: checkoutDetails?.cartData?.deliveryAddress?.state,
      location: checkoutDetails?.cartData?.deliveryAddress?.location,
    }
  }
  else { 
    return {
      city: checkoutDetails?.billingAddressAndSaveCard?.city,
      postalCode: checkoutDetails?.billingAddressAndSaveCard?.pincode,
      countryCode: checkoutDetails?.countryCodeNumeric,
      state: checkoutDetails?.billingAddressAndSaveCard?.state,
      streetAddress1: checkoutDetails?.billingAddressAndSaveCard?.addressline1,
      streetAddress2: checkoutDetails?.billingAddressAndSaveCard?.addressline2,
      streetAddress3: '',
      location: checkoutDetails?.billingAddressAndSaveCard?.location,
    }
  }
}

export const getAvsAddressPostacode = (checkoutDetails, AvsKey) => {
  if (isDeliveryDisposition(checkoutDetails?.service)) {
    if (AvsKey === ADDRESS) {
      return checkoutDetails?.billingAddressAndSaveCard?.defaultAddressSelected
        ? `${checkoutDetails?.cartData?.deliveryAddress?.addressLines[0] + checkoutDetails?.cartData?.deliveryAddress?.addressLines[1]}`
        : checkoutDetails?.billingAddressAndSaveCard?.fulladdress;
    }
    if (AvsKey === POSTAL_CODE) {
      return checkoutDetails?.billingAddressAndSaveCard?.defaultAddressSelected
        ? checkoutDetails?.cartData?.deliveryAddress?.pinCode
        : checkoutDetails?.billingAddressAndSaveCard?.pincode;
    }
  }
  if (isPickupDisposition(checkoutDetails?.service) || checkoutDetails?.isAddNewCard) {
    if (AvsKey === ADDRESS) {
      return checkoutDetails?.billingAddressAndSaveCard?.fulladdress;
    }
    if (AvsKey === POSTAL_CODE) {
      return checkoutDetails?.billingAddressAndSaveCard?.pincode;
    }
  }
};

export const getGlobalPaymentCreditCardHiddenForm = paymentCardDetails =>
  window?.GlobalPayments?.ui?.form?.({
    fields: {
      'card-number': {
        placeholder: '•••• •••• •••• ••••',
        target: '#card-number',
        value: paymentCardDetails?.cardNumber,
      },
      'card-expiration': {
        placeholder: 'MM / YYYY',
        target: '#card-expiration',
        value: paymentCardDetails?.cardExpDate,
      },
      'card-cvv': {
        placeholder: '•••',
        target: '#card-cvv',
        value: paymentCardDetails?.cardCVV,
      },
      'card-holder-name': {
        placeholder: 'xxxx xxxx',
        target: '#card-holder-name',
        value: paymentCardDetails?.cardHolderName,
      },
      submit: {
        value: 'Submit',
        target: '#payment-provider-place-order-form',
        label: translateWithI18Next(TRANSLATE_MAPPING_KEY?.PLACE_ORDER),
      },
    },
    styles: {
      'button[type=button]': {
        border: 'none',
        background: 'none',
        cursor: 'pointer',
        height: '44px',
        color: '#FFFFFF00',
      },
      'button[type=button]:hover': {
        border: 'none',
      },
    },
  });

export const getOneTimeGlobalPaymentToken = params => {
  const { checkoutDetails, updateCheckoutDetails } = params;
  const { paymentCardDetails } = checkoutDetails;

  const globalPaymentHiddenForm = getGlobalPaymentCreditCardHiddenForm(paymentCardDetails);

  globalPaymentHiddenForm?.ready(() => {
    console.log('Global Payment Card Form Ready');
  });

  globalPaymentHiddenForm?.on('token-success', response => {
    updateCheckoutDetails({
      globalPaymentsOneTimeResponse: response,
      showPlaceOrderLoading: true

    });
  });

  globalPaymentHiddenForm?.on('token-error', response => {
    // Show error to the consumer
    console.log('Error on Global Payment Card Form');
  });

  globalPaymentHiddenForm?.on('error', response => {
    // Show error to the consumer
    console.log('Error on Global Payment Card Form');
  });
};

export const dispatchGlobalPaymentsGenerateToken = (checkoutDetails, updateCheckoutDetails, props) => {
  (checkoutDetails?.isClickAddPayment || checkoutDetails?.isAddNewCard || checkoutDetails?.globalPaymentsAccesstoken) &&
  checkoutDetails?.dispatch(
    globalPaymentsGenerateToken(
      {
        tenantId: checkoutDetails?.tenantId,
        overrideRequestHeader: true,
        authToken: checkoutDetails?.RNAtoken,
        appchannel: checkoutDetails?.appchannel,
        accessTokenUsage: checkoutDetails?.globalPaymentsAccesstoken && checkoutDetails?.tender?.name !== '' ? MULTIPLE : SINGLE,
      },
      param => {
        if(checkoutDetails?.globalPaymentsAccesstoken && checkoutDetails?.tender?.name !== '') {
          updateCheckoutDetails({
            globalPaymentsMultipleUsageAccesstoken : param,
          })
        }
        else {
          updateCheckoutDetails({ globalPaymentsAccesstoken: param?.clientToken });
          window?.GlobalPayments?.configure?.({
          accessToken: param?.clientToken,
          env: getGlobalPaymentsEnvironment(),
          });
        }
      },
      error => {
        if (isCurrentPageRedirectFromRNA(window.location)) {
          window.ReactNativeWebView.postMessage(JSON.stringify({error: error}));
        }
        redirectToPaymentFailurePage({...props});
    }
    ),
  );
};

export const dispatchGlobalPaymentsAddressValidateAction = (checkoutDetails, updateCheckoutDetails, props) => {
  const { dispatch,  globalPaymentsOneTimeResponse, paymentCardDetails, globalPaymentsMultipleUsageAccesstoken} =
    checkoutDetails;
  const { merchantId, reference } = globalPaymentsOneTimeResponse?.details;
  const postData = {
    account_name: globalPaymentsMultipleUsageAccesstoken?.transactionProcessingAccountName,
    merchant_id: merchantId,
    channel: GLOBAL_PAYMENTS_ADDRESS_VALIDTAION_PAYLOAD_CONSTANTS?.CHANNEL,
    capture_mode: GLOBAL_PAYMENTS_ADDRESS_VALIDTAION_PAYLOAD_CONSTANTS?.CAPTURE_MODE,
    country: checkoutDetails?.countryCode,
    type: GLOBAL_PAYMENTS_ADDRESS_VALIDTAION_PAYLOAD_CONSTANTS?.TYPE,
    amount: (checkoutDetails?.finalAmount * checkoutDetails?.currencyConversionFactor)?.toFixed(0)?.toString(),
    currency: checkoutDetails?.currencyCode,
    reference: reference,
    payment_method: {
      first_name: checkoutDetails?.userFirstName,
      last_name: checkoutDetails?.userLastName,
      entry_mode: GLOBAL_PAYMENTS_ADDRESS_VALIDTAION_PAYLOAD_CONSTANTS?.ENTRY_MODE,
      card: {
        number: paymentCardDetails?.cardNumber?.replace(/\s/g, ""),
        expiry_month: paymentCardDetails?.cardExpDate?.split?.('/')?.[0].trim?.(),
        expiry_year: paymentCardDetails?.cardExpDate?.split?.('/')?.[1]?.trim?.(),
        cvv: paymentCardDetails?.cardCVV,
        cvv_indicator: GLOBAL_PAYMENTS_ADDRESS_VALIDTAION_PAYLOAD_CONSTANTS?.CVV_INDICATOR,
        avs_address: getAvsAddressPostacode(checkoutDetails, ADDRESS),
        avs_postal_code: getAvsAddressPostacode(checkoutDetails, POSTAL_CODE),
      },
    },
  };
  const avsPayload = {
    address: postData,
    authToken: globalPaymentsMultipleUsageAccesstoken?.clientToken,
    overrideRequestHeader: true,
  };
  dispatch(
    globalpaymentsAddressValidate(
      avsPayload,
      response => {
        updateClickPlaceOrderState(checkoutDetails, updateCheckoutDetails);
      },
      error => {
        redirectToPaymentFailurePage({
          ...props,
          isCardValidateFailedScreen: true,
        });
      },
    ),
  );
};

export const dispatchGlobalpaymentsInitiatePaymentAction = (props, checkoutDetails) => {
  let postData = {};
  if (checkoutDetails?.tender?.name === PAYMENT_TENDER_TYPES?.CREDIT_CARD) {
    const getBrowserData = window?.GlobalPayments?.ThreeDSecure?.getBrowserData();
    getBrowserData.colorDepth = GLOBAL_PAYMENTS_BROWSER_DATA_VALUES?.COLOR_DEPTH; //-- need remove
    postData = {
      token: checkoutDetails?.globalPaymentsOneTimeResponse?.paymentReference,
      accessToken: checkoutDetails?.globalPaymentsAccesstoken,
      tenderType: checkoutDetails?.tender?.name,
      orderId: checkoutDetails?.orderId,
      saveCardId: checkoutDetails?.cardid,
      IssaveCard: checkoutDetails?.billingAddressAndSaveCard?.defaultSaveCard, // --- if logged in
      isStore3DS: false, //--- need to check
      threeDSServerId: checkoutDetails?.globalPaymentCheck3DsVersion?.enrolled === GLOBAL_PAYMENTS_CONSTANTS?.ENROLLED ? checkoutDetails?.globalPaymentCheck3DsVersion?.serverTransactionId : '',
      billingAddress: getBillingOrShippingAddress(checkoutDetails),
      shippingAddress: getBillingOrShippingAddress(checkoutDetails),
      browserData: getBrowserData,
      cardNickName: checkoutDetails?.cardid ? checkoutDetails?.cardNickName?.trim?.() : checkoutDetails?.billingAddressAndSaveCard?.nickName?.trim?.(),
      cardExpMonth: checkoutDetails?.cardid ? checkoutDetails?.expiryDate?.substr(0,2).trim?.() : checkoutDetails?.globalPaymentsOneTimeResponse?.details?.expiryMonth,
      cardExpYear: checkoutDetails?.cardid ? checkoutDetails?.expiryDate?.substr(2).trim?.() : checkoutDetails?.globalPaymentsOneTimeResponse?.details?.expiryYear,
      nameOnCard:checkoutDetails?.cardid ? checkoutDetails?.nameOnCard?.trim?.() : checkoutDetails?.globalPaymentsOneTimeResponse?.details?.cardholderName,
      cvv:checkoutDetails?.savedCardCvv 
    };
  } else {
    postData = {
      token: checkoutDetails?.globalPaymentsOneTimeResponse?.paymentReference,
      amount: checkoutDetails?.finalAmount?.toString(),
      tenderType: checkoutDetails?.tender?.name,
      orderId: checkoutDetails?.orderId,
      customerId: '',
      paymentId: '',
    };
  }
  const initaitePaymentPayload = {
    data: postData,
    tenantId: checkoutDetails?.tenantId,
    overrideRequestHeader: true,
    authToken: checkoutDetails?.RNAtoken,
    appchannel: checkoutDetails?.appchannel,
  };

  checkoutDetails?.dispatch(
    globalpaymentsInitiatePayment(
      initaitePaymentPayload,
      response => paymentTrancationSuccessHandler(props, response),
      error => paymentTrancationErrorHandler(props, error),
    ),
  );
};

export const checkGlobalPayment3DsVersion = async (checkoutDetails, updateCheckoutDetails, props) => {
  loadScript(
    `${window.location.origin}/${config(GLOBAL_PAYMENTS_3DS_FILE_URL)}`,
    GLOBAL_PAYMENTS_CONSTANTS?.GLOBAL_PAYMENTS_3DS_SCRIPT_ID,
    async () => {
      try {
        const authToken = await AuthManager.getInstance().checkAndGetAuthToken();
        const versionCheckData = await window?.GlobalPayments?.ThreeDSecure?.checkVersion(
          gloablPaymentCheckVersionUrl?.url,
          {
            token: checkoutDetails?.globalPaymentsOneTimeResponse?.paymentReference,
            orderId: checkoutDetails?.orderId,
            saveCardId: checkoutDetails?.cardid,
          },
          {
            'x-tenant-id': checkoutDetails?.tenantId,
            ...networkConfig?.getXCorelationHeader(),
            Authorization: 'Bearer ' + authToken,
          },
        );

        updateCheckoutDetails({ globalPaymentCheck3DsVersion: versionCheckData });
      } catch (error) {

        paymentTrancationErrorHandler({ ...props }, error);
      }
    },
  );
};

export const initiateGlobalPayment3DsAuthentication = async (checkoutDetails, updateCheckoutDetails, props) => {
  const getBrowserData = window?.GlobalPayments?.ThreeDSecure?.getBrowserData();

  try {
    const authToken = await AuthManager.getInstance().checkAndGetAuthToken();
    getBrowserData.colorDepth = GLOBAL_PAYMENTS_BROWSER_DATA_VALUES?.COLOR_DEPTH; //--- color
    getBrowserData.acceptHeader = GLOBAL_PAYMENTS_BROWSER_DATA_VALUES?.ACCEPT_HEADER;

    const authenticationData = await window?.GlobalPayments?.ThreeDSecure?.initiateAuthentication(
      gloablPayment3DSIntitiateAuthUrl?.url,
      {
        token: !checkoutDetails?.cardid ? checkoutDetails?.globalPaymentsOneTimeResponse?.paymentReference : '',
        orderId: checkoutDetails?.orderId,
        serverTransactionId: checkoutDetails?.globalPaymentCheck3DsVersion?.serverTransactionId,
        browserData: getBrowserData,
        saveCardId: checkoutDetails?.cardid,
        billingAddress: getBillingOrShippingAddress(checkoutDetails),
        shippingAddress: getBillingOrShippingAddress(checkoutDetails),
        challengeWindow: {
          windowSize: window?.GlobalPayments?.ThreeDSecure?.ChallengeWindowSize?.Windowed600x400,
          displayMode: 'lightbox',
        },
      },
      {
        'x-tenant-id': checkoutDetails?.tenantId,
        ...networkConfig?.getXCorelationHeader(),
        Authorization: 'Bearer ' + authToken,
      },
    );

    updateCheckoutDetails({ globalPaymentAuthenticationData: authenticationData });
  } catch (error) {
    paymentTrancationErrorHandler({ ...props }, error);
    console.error('An error occurred', error.reasons);
  }
};

export const dispatchGlobalPaymentCardVerification = props => {
  const { checkoutDetails} = props;
  const { dispatch, globalPaymentsAccesstoken, isAddNewCard } = checkoutDetails;
  const payload = {
    cardDetails: {
      token: checkoutDetails?.globalPaymentsOneTimeResponse?.paymentReference,
      accessToken:globalPaymentsAccesstoken,
      customerId: checkoutDetails?.customerId,
    },
    tenantId: checkoutDetails?.tenantId,
  };
  dispatch(
    globalPaymentsVerifyCard(
      payload,
      response => {
        if (response.responseCode !== null && response.status === VERIFIED) {
          dispatchGlobalPaymentSaveCardDipatch(props, response);
        }
        else {
          redirectToPaymentFailurePage({ ...props, isCardValidateFailedScreen: true, isAddNewCard: isAddNewCard});
        }
      },
      error => {
        redirectToPaymentFailurePage({ ...props, isCardValidateFailedScreen: true, isAddNewCard: isAddNewCard});
      },
    ),
  );
};

export const dispatchGlobalPaymentSaveCardDipatch = (props, response) => {
  const { checkoutDetails } = props;
  const { dispatch } = checkoutDetails;
  const payload = {
    savecard: {
      customerId: checkoutDetails?.customerId,
      accessToken: checkoutDetails?.globalPaymentsAccesstoken,
      token: checkoutDetails?.globalPaymentsOneTimeResponse?.paymentReference,
      cardNickName: checkoutDetails?.billingAddressAndSaveCard?.nickName?.trim?.(),
      nameOnCard: checkoutDetails?.globalPaymentsOneTimeResponse?.details?.cardholderName?.trim?.(),
      maskedCardNumber: response?.cardLastFour,
      billingAddress: getBillingOrShippingAddress(checkoutDetails),
      cardExpMonth: checkoutDetails?.globalPaymentsOneTimeResponse?.details?.expiryMonth,
      cardExpYear: checkoutDetails?.globalPaymentsOneTimeResponse?.details?.expiryYear,
      type: checkoutDetails?.globalPaymentsOneTimeResponse?.details?.cardType,
      shippingAddress: getBillingOrShippingAddress(checkoutDetails),
    },
    tenantId: checkoutDetails?.tenantId,
  };
  dispatch(
    GlobalpaymentSaveCard(
      payload,
      params => {
        if (params.sucesss) {
          const reqPayload = {
            updateUserData: true,
          };
          dispatch(getCustomerInfo(reqPayload));
          redirectToAccountPage(props, 'myPaymentMethods');
        } else {
          redirectToPaymentFailurePage({ ...props, isCardValidateFailedScreen: true });
        }
      },
      error => {
        redirectToPaymentFailurePage({ ...props, isCardValidateFailedScreen: true });
      },
    ),
  );
};



export const getLastUsedPaymentMethod = checkoutDetails => {
  const { lastUsedPaymentMethod = '', allowedTenders = [] } = checkoutDetails;
  const paymentMethodPresent = checkPaymentMethod(allowedTenders, lastUsedPaymentMethod);
  if (paymentMethodPresent) {
    return lastUsedPaymentMethod === PAYMENT_TENDER_TYPES?.PAY_BY_CASH 
      ? {
          name: PAYMENT_TENDER_TYPES?.CREDIT_CARD,
          payload: { tender: PAYMENT_TENDER_TYPES?.CREDIT_CARD },
        }
      : {
          name: lastUsedPaymentMethod,
          payload: { tender: lastUsedPaymentMethod },
        };
  }
  return {
    name: '',
    payload: { tender: '' },
  };
};

export const getSavedCardId = checkoutDetails => {
  const { lastUsedPaymentMethod = '', allowedTenders = [] } = checkoutDetails;
  const paymentMethodPresent = checkPaymentMethod(allowedTenders, lastUsedPaymentMethod);
  return paymentMethodPresent && 
    (lastUsedPaymentMethod === PAYMENT_TENDER_TYPES?.CREDIT_CARD ||
      lastUsedPaymentMethod === PAYMENT_TENDER_TYPES?.PAY_BY_CASH)
    ? checkoutDetails?.savedCards?.[0]?.id
    : '';
};

export const updateBillingAddressDetails = checkoutDetails => {
  const isItSavedCard = getSavedCardId(checkoutDetails);
  const savedCard = checkoutDetails?.savedCards[0];
  const { billingAddressAndSaveCard } = checkoutDetails;
  return isItSavedCard
    ? {
      ...billingAddressAndSaveCard,
        location:savedCard?.billingAddress?.location,
        addressline1: savedCard?.billingAddress?.addressLines[0],
        addressline2: savedCard?.billingAddress?.addressLines[1],
        addressline3: savedCard?.billingAddress?.addressLines[2],
        city: savedCard?.billingAddress?.city,
        pincode: savedCard?.billingAddress?.pinCode,
        state: savedCard?.billingAddress?.state,
      }
    : { ...billingAddressAndSaveCard };
}